/**
 * Created by Jie Gao on 2021-02-22.
 */
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TweenLite, TimelineLite, Linear} from "gsap";
import {GGGameConfig} from "../../GGGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GGGameModuleConfig} from "../../GGGameModuleConfig";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {FontStyleConfig} from "../../config/FontStyleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {GGParsedGameData} from "../../server/data/GGParsedGameData";

export class UpgradeFSIntroView extends BaseView {
    private _container:PIXI.Container;
    private _featureSplash:PIXI.Sprite;
    private _featureAnimation:PIXI.spine.Spine;
    private _layer:PIXI.Container;
    private _fsNumber:PIXI.BitmapText;
    private _xBomGuaranteed:PIXI.Text;

    constructor() {
        super();
        this._layer = StageManager.getLayer(GGGameConfig.instance.LAYERS.FREESPIN_INTRO.name);
    }

    protected initAnimations() {
        this._container = new PIXI.Container();
        this._featureSplash = new PIXI.Sprite();
        this._featureSplash.position.set(0, -35);
        this._container.addChild(this._featureSplash);

        this._xBomGuaranteed = new PIXI.Text(Translation.translate("Guaranteed xBomb"), {
            fill : 0xAAE042,
            fontFamily : "Open Sans",
            wordWrap : true,
            wordWrapWidth : 550,
            fontSize : 56
        });
        this._xBomGuaranteed.visible = false;
        this._xBomGuaranteed.position.set(0 - this._xBomGuaranteed.width * 0.5, 265);

        this._fsNumber = new PIXI.BitmapText("4", FontStyleConfig.FSNUMBEROnFSIntro);
        this._fsNumber.position.set(-6 - this._fsNumber.width * 0.5, 142);
        this._fsNumber.visible = false;
        this.addChild(this._container);
    }

    public show(data:GGParsedGameData):TimelineLite {
        const bombGuaranteed:boolean = data.bombGuarantee;
        const evil4multiplier:number = data.topTrain.evil4multiplier;
        const multiplierBeforeFeast:number = data.multiplierBeforeFeast;
        const scatterNum:number = (data.numScattersEnterFS > 8) ? 4 : 3;

        const tl:TimelineLite = new TimelineLite();
        this.visible = true;
        this.alpha = 0;
        this._layer.addChild(this);
        const startTime:number = 0.5;
        const animationDuration:number = 2;
        const gapDuration:number = 0.5;

        const featureSplashTextureName:string = `fsIntro_super_${scatterNum}s${bombGuaranteed ? "_bomb" : ""}`;
        this._featureAnimation = new PIXI.spine.Spine(GameResources.getSpineAsset(featureSplashTextureName));
        this._featureAnimation.pivot.set(0.5, 0.5);
        this._featureAnimation.name = featureSplashTextureName;
        this._featureAnimation.renderable = false;
        this._featureAnimation.position.set(0, 0);
        this._featureSplash.addChild(this._featureAnimation);
        this._featureSplash.addChild(this._fsNumber);
        this._featureSplash.addChild(this._xBomGuaranteed);

        tl.add([
            () => {
                GGGameModuleConfig.soundPlayer.playFSIntroSound("super", bombGuaranteed);
                this._featureAnimation.state.setAnimation(0, "FMS_Intro", false);
                this._featureAnimation.renderable = true;
            },
            TweenLite.to(this, 0, {alpha : 1})
        ], startTime);
        tl.add(GGGameModuleConfig.fsCounter.updateToSpinsLeft(4, `fsBadge_super${bombGuaranteed ? "_bomb" : ""}`), startTime + animationDuration + gapDuration);
        tl.add(() => {
            this._fsNumber.visible = true;
            if(bombGuaranteed) {
                this._xBomGuaranteed.visible = true;
            }
        });
        const duration:number = tl.duration();
        if(multiplierBeforeFeast > -1) {
            tl.add(GGGameModuleConfig.topTrain.multiplierCountUp(evil4multiplier), duration + gapDuration);
            const patchTl:TimelineLite = GGGameModuleConfig.patchEvil4Multiplier.showEvil4Multipliers(data.reels[0], data.topTrain.evil4Symbol, evil4multiplier, data.totalNumberOfWays[0]);
            if(patchTl.duration() > 0) {
                tl.add(() => GGGameModuleConfig.soundPlayer.playEvil4GoblinLandsOnReel1Sound());
            }
            tl.add(patchTl);
        }

        tl.add(() => {TweenLite.to(this, 0.4, {alpha : 0, ease : Linear.easeOut})});
        return tl;
    }

    public stopPresentation():void {
        this.visible = false;
        this._featureAnimation.state.setEmptyAnimation(0, 0);
        this._featureAnimation.renderable = false;
        this._featureAnimation.visible = false;
        this._fsNumber.visible = false;
        this._xBomGuaranteed.visible = false;
        this._layer.removeChild(this);
    }

    protected onResize(resizeData:IResizeData):void {
        const splashScale:number = resizeData.orientation === Orientation.PORTRAIT ? 0.9 : 0.7;
        this._container.position.set(360, 360);
        this._featureSplash.scale.set(splashScale, splashScale);
    }
}